<template>
    <!-- same as gallerPhoto, using AlbumPhoto for both  -->
    <div id="album-photo">
        <div v-if="error" class="container mtb-80">
            <app-back :title="error"></app-back>
        </div>
        <div v-if="albumPhoto !== null && albumPhoto.hasOwnProperty('photo')">
            <app-header :info="albumPhoto.photo" :title="capitalize(title)" :imagePath="imagePath" isType="photo" isClass="is-fullheight1"></app-header>

            <div class="columns nav-container mtb-80 rel">
                <div class="breadcrumbs-parent" style="display:flex; top: -50px; left: 20px">
                    <ul>
                        <li><router-link :to="'/' + albumPhoto.photo.album.slug">{{ capitalize(albumPhoto.photo.album.name)}}</router-link></li>
                        <li><router-link :to="'/' + albumPhoto.photo.album.slug + '/' + albumPhoto.photo.location.slug">{{ capitalize(albumPhoto.photo.location.name)}}</router-link></li>
                        <li v-text="capitalize(this.title)"></li>
                    </ul>
                </div>
                <!-- prev -->
                <div class="column" v-if="albumPhoto.prev">
                    <p class="wide has-text-centered" v-if="albumPhoto.prev.hasOwnProperty('location')"> {{ albumPhoto.prev.location.name | capitalize }}</p>
                    <p class="intro has-text-centered">{{ albumPhoto.prev.date }}</p>
                    <a class="prev" v-if="albumPhoto.prev" :href="albumPhoto.prev.slug">
                        <img :src="getPhoto(albumPhoto.prev)" :alt="albumPhoto.prev.name" />
                    </a>
                </div>

                <div class="column special-blockquote complex-line column">
                    <span class="related weather"></span>
                    <blockquote class="item">
                        <span>{{ albumPhoto.quote.quote }}</span>
                        <cite>{{ albumPhoto.quote.author }}</cite>
                    </blockquote>
                </div>

                <!-- next -->
                <div class="column has-text-right" v-if="albumPhoto.next">
                    <p class="wide has-text-centered" v-if="albumPhoto.next.location.hasOwnProperty('location')">{{ albumPhoto.next.location.name | capitalize }}</p>
                    <p class="intro has-text-centered">{{ albumPhoto.next.date }}</p>
                    <a class="next" v-if="albumPhoto.next" :href="albumPhoto.next.slug">
                        <img :src="getPhoto(albumPhoto.next)" :alt="albumPhoto.next.name" />
                    </a>
                </div>
            </div>
            <h3 class="links"><a :href="slug">Vse slike</a></h3>

            <app-google-map :mapName="capitalize(this.title)" :glat="albumPhoto.photo.location.lat" :glng="albumPhoto.photo.location.lng"></app-google-map>
        </div>
    </div>
</template>

<script>
import { ApiHome, GalleryAlbumLink } from '../../.env';
import { mapGetters, mapActions } from 'vuex';
import StringsMixin from '../../mixins/StringsMixin';
import HeaderBar from '../../components/layout/HeaderBar.vue';
import BackButton from '../../components/layout/BackButton.vue';
import GoogleMaps from '../../components/elements/gmaps/GoogleMaps.vue';
import Silentbox from '../../components/elements/silentbox/Silentbox.vue';

export default {
    props: ['photo', 'photoDetails'],
    mixins: [StringsMixin],

    data() {
        // console.log('photo: ', this.photo, this.photoDetails, this);
        return {
            endpoint: ApiHome+ 'photo/' + this.photo,
            photoSize: '1960',
            // photoSize: 'original',
            photoSmall: '300'
        }
    },

    components: {
        'app-header': HeaderBar,
        'app-back': BackButton,
        'app-google-map': GoogleMaps,
        'app-sb': Silentbox,
    },

    computed: {
        ...mapGetters([
            'albumPhoto',
            'loading',
            'error',
            'title'
        ]),

        imagePath() {
            return this.albumPhoto.photo.imagePath;
        },
        slug() {
            return GalleryAlbumLink + this.albumPhoto.photo.album.slug;
        }
    },

    methods: {
        fetchPhoto() {
            // console.log('FETCH photo (album-photo): ', this.photo, this.endpoint, this.album, this.$router);
            let album = '';
            if(typeof(this.album) !== 'undefined') {
                album = this.album;
            }
            let data = {
                endpoint: this.endpoint,
                type: 'photo',
                photo: this.photo,
                // album: !!this.album
            };
            console.log('PHOTO data: ', data);
            this.$store.dispatch('fetchPhoto', data);
        },

        getPhoto(item) {
            return item.imagePath;
        }
    },

    created() {
        this.fetchPhoto();
    }
}
</script>
<style lang="scss">
    .hero-image {
        margin: 0 auto;
        width: 100%;
    }
    .hero.is-fullheight {
        padding-top: 80px;
        min-height: auto;
    }
    .hero.is-fullheight img {
        width: auto !important;
        display: block;
        margin: 70px auto !important;
    }
    form#search {
        display:inline-block;
        text-align: right;
        // width: 200px !important;
        width: 100%;
        clear: both;
        margin-bottom: 10px;
        position: relative;
    }
    .input.searchInput {
        background: transparent;
        box-shadow:none !important;
        border-top: none;
        border-left: none;
        border-right: none;
        border-bottom: 1px dashed rgba(10, 10, 10, 0.6);
        width: 300px !important;
        font-size: 1.4rem;
        color: rgba(10, 10, 10, 0.4);
        font-weight: 300;
    }

    .close {
        cursor: pointer;
        color: rgba(10, 10, 10, 0.3);
        position: absolute;
        bottom: 10px;
        right: 10px;
        font-style: normal;
        font-weight: 300;
    }

    .full-page {
        width: 100%;
        display: inline-block;
    }
</style>




// WEBPACK FOOTER //
// src/views/albums/AlbumPhoto.vue